/** Removes underscores before lowercase ASCII letters and capitalizes those letters; other characters remain unchanged. */
export function snakeToCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/** Prefixes each uppercase ASCII letter with an underscore and lowercases it, including leading letters and acronyms. */
export function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
